export default __webpack_public_path__ + "static/media/fb.d0587eb3.svg";